// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bosnia & Herzegovina */
const BA = /^(?:6040\d{5}|6(?:03|[1-356]|44|7\d)\d{6})$/;

export default BA;
